import {Settings} from '../Settings';

export function openExternalLink(url, target = '_blank', features) {
    if (Settings.onPoki) {
        PokiSDK.openExternalLink(url);
        return;
    }
    return window.open(url, target, features);
}

// Delegation covers menus built later, including links inside SVG icons.
// The character selector installs the same handler on its own document.
export function installExternalLinkRouting(doc = document) {
    const open = event => {
        if (!Settings.onPoki || event.defaultPrevented || event.button > 1) return;
        const link = event.target.closest?.('a[href]');
        const href = link?.getAttribute('href');
        if (!href || href.startsWith('#')) return;
        const url = new URL(href, doc.baseURI);
        if (['javascript:', 'data:', 'blob:'].includes(url.protocol)) return;
        if (url.origin === new URL(doc.baseURI).origin && link.target !== '_blank') return;

        event.preventDefault();
        // Prevent nested link clicks from also activating their parent button.
        event.stopImmediatePropagation();
        openExternalLink(url.href);
    };
    doc.addEventListener('click', open, {capture: true});
    doc.addEventListener('auxclick', open, {capture: true});
}
